<template>
   <v-container>
        <div class="text-left" style="margin-bottom:20px;">
            <router-link to="/uk">
                <v-btn
                    color="secondary"
                    class="text-right"
                    style="width:250px"
                >
                    Back
                </v-btn>
            </router-link>
        </div>           
      <v-row>
        <v-col cols="12" class="text-left">
          <h1>February 6</h1>
          <div class="text-left">
            <p>Stayed at Oxford</p>
            <p>Had the smallest room possible so no desk at all to update this.</p>
            <p>Car iced up again but we went for a walk around oxford.</p>
            <p>Oxford University</p>
            <a href="/uk/06Oxford.jpeg"><img alt="Oxford University" class="uitk-image-media" src="/uk/06Oxford.jpeg" style="width: 17%; height: auto;"></a>
            <a href="/uk/06Oxford2.jpeg" target="_blank"><img alt="Oxford University" class="uitk-image-media" src="/uk/06Oxford2.jpeg" style="width: 17%; height: auto;"></a>                
            <p>Oxford University Pokemon not good enough for James</p>
            <a href="/uk/06Pokemon.jpeg" target="_blank"><img alt="Oxford University Pokemon" class="uitk-image-media" src="/uk/06Pokemon.jpeg" style="width: 17%; height: auto;"></a>
            <p>Driving around the Cotswolds looking for some pretty village that has a river running through it.  Maybe drove past it as Franks map had 20 stops but only 5 town names and we were running out of time.</p>
            <a href="/uk/06Town.jpeg" target="_blank"><img alt="Cotswolds Town" class="uitk-image-media" src="/uk/06Town.jpeg" style="width: 17%; height: auto;"></a>
            <a href="/uk/06Town2.jpeg" target="_blank"><img alt="Cotswolds Town" class="uitk-image-media" src="/uk/06Town2.jpeg" style="width: 17%; height: auto;"></a>
            <p>Found a town with water running through it.</p>
            <a href="/uk/06Town3.jpeg" target="_blank"><img alt="Cotswolds Town" class="uitk-image-media" src="/uk/06Town3.jpeg" style="width: 17%; height: auto;"></a>
            <a href="/uk/06Town4.jpeg" target="_blank"><img alt="Cotswolds Town" class="uitk-image-media" src="/uk/06Town4.jpeg" style="width: 17%; height: auto;"></a>
            <a href="/uk/06Town5.jpeg" target="_blank"><img alt="Cotswolds Town" class="uitk-image-media" src="/uk/06Town5.jpeg" style="width: 17%; height: auto;"></a>
            <a href="/uk/06PhoneBox.jpeg" target="_blank"><img alt="Cotswolds Town Phone Box" class="uitk-image-media" src="/uk/06PhoneBox.jpeg" style="width: 17%; height: auto;"></a>
            <p>Common sign - closed for winter.</p>
            <a href="/uk/06Closed.jpeg" target="_blank"><img alt="Cotswolds Town closed for winter" class="uitk-image-media" src="/uk/06Closed.jpeg" style="width: 17%; height: auto;"></a>

        </div>      
        </v-col>
      </v-row>
    </v-container>
  </template>
  
  <script>
  
  //vue 3 style
  import { ref } from 'vue'
  
  export default {
    name: 'HomeView',
    setup() {
    }
  }
  </script>